import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /lockers validation

const lockerAddressSchema = yup.object({
  latLong: yup.array().of(yup.string()).min(2).required(),
});

const lockerSchema = yup.object({
  id: yup.string().required(),
  name: yup.string().required(),
  address: lockerAddressSchema.required(),
});

const lockersSchema = yup.array().of(lockerSchema);

export type TLockerItemResponse = Asserts<typeof lockerSchema>;

export type TLockersResponse = Asserts<typeof lockersSchema>;

const validateLockersResponse = (response: any): TLockersResponse => lockersSchema.validateSync(response);

export default validateLockersResponse;
